import type { NavigationHookAfter } from 'vue-router';
import { useMainStore } from '@/store/main';

export const setRouteLayout: NavigationHookAfter = (to) => {
	const mainStore = useMainStore();
	mainStore.viewLayout = to.meta.layout || 'signup';
};
